'use strict';
var forsyningsservice = forsyningsservice || {};
const siteNavToggle = document.getElementById('input-toggle__site-nav');

forsyningsservice.navigation = forsyningsservice.navigation || function () {

	function init() {
		siteNavToggle.addEventListener('click', function() {
    		forsyningsservice.search.closeSearch();
		});
	}

	function closeNav() {
		siteNavToggle.checked = false;
	}

	return {
		init : init,
		closeNav: closeNav
	};

}();